import React, { useState, useRef, useEffect } from 'react';
import axioPath from '../../../../../../api/axioPath';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import './typeaheadAdmin.scss';

const SearchTypeahead = ({
  placeholder,
  minLength,
  asyncSearch,
  searchUrl,
  filterBy,
  pageType,
  toggle,
  defaulTitle,
  title,
  pageName,
  transparent,
  focusOnShow,
  searchHandler,
  background,
  color,
  callBack,
  setCompanyNameValue
}) => {
  const ref = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  let defaultTxt = defaulTitle;
  if (title) {
    defaultTxt = title.toString();
  }

  const [defaultState, setDefaultState] = useState(defaultTxt);

  useEffect(() => {
    if (focusOnShow) {
      ref.current.focus();
    }
    setDefaultState(defaultTxt)
  }, [defaultTxt]);


  const handleSearch = async (query) => {
    const token = localStorage.getItem("token")
    axioPath.get(`/user/admin/companyList1?companyName=${query}`, {
      headers: {
        Authorization: token,
      },
    }).then((response) => {
      if (response && response.data && response.data.status === 'SUCCESS' && response.data.payload) {
        const options = response.data.payload.map((data, index) => ({
          id: index,
          title: data,
          description: data
        }));      
        setOptions(options);
      }
    }).catch((err) => {
    })
  }

  return (
    asyncSearch && (
      <>
        <div
          className={`type-ahead-search-input ${transparent ? "search-input-transparent" : ""
            }`}
        >
          <AsyncTypeahead
            ref={ref}
            multiple={false}
            id={Math.random().toString()}
            labelKey="title"
            filterBy={["title", "description"]}
            isLoading={isLoading}
            minLength={minLength}
            onSearch={handleSearch}
            options={options}
            placeholder={placeholder}
            defaultInputValue={defaultState || ""}
            onInputChange={(text) => {
              setDefaultState(text);
              handleSearch(text);
            }}
            onChange={(event) => {
              if (event.length !== 0 && event[0].title) {
                handleSearch(event[0].title.toString());
                setDefaultState(event[0].title);
                setCompanyNameValue(event[0].title)
              }
            }}
            renderMenuItemChildren={(option) => <span>{option[filterBy]}</span>}
          />
        </div>
      </>
    )
  );
};

SearchTypeahead.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  asyncSearch: PropTypes.bool,
  searchUrl: PropTypes.string,
  focusOnShow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
};

SearchTypeahead.defaultProps = {
  placeholder: '',
  minLength: 1,
  asyncSearch: true,
  /**
   * @todo : SearchUrl and filterBy should be empty, this needs to be refactored after search api integration
   */
  searchUrl: 'https://api.github.com/search/users',
  filterBy: 'login',
  transparent: false,
  focusOnShow: true,
};

export default SearchTypeahead;
